<div [hidden]="this.frmGroup.get(this.configData.name)['hidden']">
<div class="box-align" *ngIf="configData.screenVersion === 'v2';">
    <div *ngIf="configData.hasOwnProperty('insideLabel') === false || configData.noLable === false">
        <div class="chips-auto-complete-label">{{ configData.label }}
          
        </div>
    </div>
    <div>
        <mat-form-field class="example-chip-list" [ngClass]="(configData.hasOwnProperty('insideLabel') == false || configData.noLable == false) ? 'paddingTop' : ''" [formGroup]="frmGroup" fxFlex="0 0 100%" appearance="{{appearance}}" color="accent">
            <div class="chip-list-drop-down-icon">
            </div>
            <mat-chip-grid #chipList aria-label="search equipment type" [formControlName]="configData.name">
                <mat-chip-row *ngFor="let option of options;let index=index;" [removable]="removable"
                    (removed)="remove(option, index)">
                    {{option.displayValue}}
                    <mat-icon matChipRemove *ngIf="removable">close</mat-icon>
                </mat-chip-row>
                
                <input [placeholder]="options.length>0?'': getPlaceholder()" id="searcOptionInput" #searcOptionInput [formControl]="searcOptionCtrl" [matAutocomplete]="auto"
                    [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    (matChipInputTokenEnd)="add($event)" (click)="onFocus()" (focusout)="closePanel($event)" [class.disabled]="disabled">
            </mat-chip-grid>
            <mat-error *ngIf="frmGroup.get(configData.name).errors">
                <mat-error *ngIf="frmGroup.get(configData.name).errors.required">
                    <div class="form-field-error">
                        <span class="error-icon">
                            <img class="dhl-input-error-icon" src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
                        </span>
                        <span class="error-text" *ngIf="frmGroup.get(configData.name).errors">
                            Required
                        </span>
                    </div>
                </mat-error>
                <mat-error *ngIf="frmGroup.get(configData.name).errors?.groupValidationError">
                    <div class="form-field-error">
                        <span class="error-icon">
                            <img class="dhl-input-error-icon" src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
                        </span>
                        <span class="error-text" *ngIf="frmGroup.get(configData.name).errors">
                            {{ frmGroup.get(configData.name).errors?.groupValidationError | translate }}
                        </span>
                    </div>
                </mat-error>
            </mat-error>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" class="chips-autocomplete-panel">
                <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                    <span *ngIf="option?.iconImageUrl"><img src={{option.iconImageUrl}} type="image/svg+xml" style="width:24px;height:24px"  />  </span>
                    {{option.displayValue}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
</div>
<mat-form-field *ngIf="configData.screenVersion !== 'v2';" class="example-chip-list" [formGroup]="frmGroup" fxFlex="0 0 100%" style="padding-top: 1.6rem;"  appearance="standard" color="accent">
    <mat-label>{{ configData.label }}</mat-label>
      <mat-chip-grid #chipList aria-label="search equipment type" [formControlName]="configData.name">
          <mat-chip-row *ngFor="let option of options;let index=index;" [removable]="removable"
              (removed)="remove(option, index)">
              {{option.displayValue}}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
          </mat-chip-row>
          <input [placeholder]="options.length>0?'': getPlaceholder()" id="searcOptionInput" #searcOptionInput [formControl]="searcOptionCtrl" [matAutocomplete]="auto"
              [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="add($event)" (click)="onFocus()" (focusout)="closePanel($event)">
      </mat-chip-grid>
      <mat-error *ngIf="frmGroup.get(configData.name).errors">
          <mat-error *ngIf="frmGroup.get(configData.name).errors.required">
              Required
          </mat-error>
      </mat-error>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
              {{option.displayValue}}
          </mat-option>
      </mat-autocomplete>
  </mat-form-field>
</div>
